import { useEffect } from "preact/hooks";
import { ChatTab } from "./components/ChatTab";
import { ChatPanel } from "./components/ChatPanel";
import { GateForm } from "./components/GateForm";
import {
  panelOpen,
  escalationView,
  escalationSent,
  customerName,
  customerEmail,
} from "./store";
import { EscalationForm } from "./components/EscalationForm";
import {
  setConfig,
  showGreetingIfEmpty,
  warmupModal,
} from "./components/handlers";

export function App() {
  useEffect(() => {
    const root = document.getElementById("iskra-chat-root");
    if (!root) return;
    setConfig({
      stokeApi: root.dataset.stokeApi || "",
      n8nEscalation: root.dataset.n8nEscalation || "",
    });
  }, []);

  useEffect(() => {
    if (!panelOpen.value) return;
    // [TRACKING-HOOK] chat_opened: Når panelet åpnes — fyre GA4 event
    // "chat_open" + Meta Pixel custom event her i fremtidig sesjon.
    // Pre-warm Modal mens brukeren leser/fyller ut gate eller chatter.
    warmupModal();
    if (customerName.value && customerEmail.value) {
      showGreetingIfEmpty();
    }
  }, [panelOpen.value, customerName.value, customerEmail.value]);

  // Marker på <html> at chatten er åpen.
  //
  // Storefronten har en egen flytende CTA («Få din badstue-plan», `.lm-fab`)
  // nederst til høyre med z-index 2147483646 — altså over vår panel. Når
  // chatten utvides legger den seg oppå skrivefeltet, så kunden ikke ser hva
  // hen skriver. Vi eier ikke den knappen, men vi eier denne klassen: regelen
  // som skjuler den ligger i styles.ts og gjelder kun mens chatten er åpen.
  useEffect(() => {
    const el = document.documentElement;
    el.classList.toggle("iskra-chat-open", panelOpen.value);
    return () => el.classList.remove("iskra-chat-open");
  }, [panelOpen.value]);

  const hasCustomer = customerName.value && customerEmail.value;
  const showEscalation = escalationView.value || escalationSent.value;

  return (
    <>
      <ChatTab />
      <div
        class={`ic-panel ${panelOpen.value ? "ic-open" : ""}`}
        role="dialog"
        aria-label="Chat med Badstugutta"
        aria-hidden={!panelOpen.value}
      >
        {!hasCustomer && !showEscalation
          ? <GateForm />
          : showEscalation
          ? <EscalationForm />
          : <ChatPanel />}
      </div>
    </>
  );
}
